<style scoped lang="scss">

</style>

<template>
    <div class="uk-grid">
        <div class="uk-width-1-1">
            <legend>Monthly Income for {{ label }}</legend>
        </div>
        <div class="uk-width-1-1">
            <table class="uk-table uk-table-striped">
                <thead>
                <tr>
                    <th>Income Type</th>
                    <th>Income Interval</th>
                    <th>Income Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="type in types">
                    <td>{{ type.label }}</td>
                    <td>
                        <div v-if="type.requireInterval">
                            <select v-model="type.interval"
                                    placeholder="How often do you get paid?"
                                    @change="onInputChanged"
                                    class="uk-select">
                                <option v-for="(label, interval) in paymentIntervals" :value="interval">{{ label }}</option>
                            </select>
                        </div>
                        <div v-else>Last 30 Days</div>
                    </td>
                    <td>
                        <vue-numeric currency="$" v-model="type.amount" @change.native="onInputChanged" type="text"></vue-numeric>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IncomeEntryForm",
        props: ['label', 'member', 'values'],
        data() {
            return {
                paymentIntervals: {
                    monthly: 'Monthly',
                    weekly: 'Weekly',
                    biweekly: 'Biweekly (every other week)',
                    bimonthly: 'Bimonthly (twice a month)',
                    annually: 'Annually',
                    other: 'Other (enter income for last 30 days)'
                },
                types: [
                    {
                        name: 'primary_monthly',
                        label: 'Monthly Gross Wages (Primary Job)',
                        requireInterval: true,
                        interval: 'monthly',
                        amount: 0,
                    },
                    {
                        name: 'secondary_monthly',
                        label: 'Monthly Gross Wages (Second Job)',
                        requireInterval: true,
                        interval: 'monthly',
                        amount: 0,
                    },
                    {
                        name: 'tertiary_monthly',
                        label: 'Monthly Gross Wages (Third Job)',
                        requireInterval: true,
                        interval: 'monthly',
                        amount: 0,
                    },
                    {
                        name: 'self_employment_monthly',
                        label: 'Self Employment',
                        requireInterval: true,
                        interval: 'monthly',
                        amount: 0,
                    },
                    {
                        name: 'alimony',
                        label: 'Gross Alimony Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'social_security',
                        label: 'Gross Social Security Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'unemployment',
                        label: 'Gross Unemployment Compensation Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'government_assistance',
                        label: 'Gross Government Assistance Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'retirement',
                        label: 'Gross Retirement Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'investment',
                        label: 'Gross Annuity or Investment Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'rent_roommate',
                        label: 'Gross Rent from roommate Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'rent',
                        label: 'Gross Rental Property Income Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'contributions',
                        label: 'Gross Contributions from Family or Friends Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },
                    {
                        name: 'other',
                        label: 'Gross Other Monthly Income Received',
                        requireInterval: false,
                        interval: null,
                        amount: 0,
                    },

                ]
            }
        },
        watch: {
            values(newValue) {
                if(newValue) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.values) {
                this.initData();
            }
        },
        methods: {
            initData() {
                _.each(this.values, value => {
                    _.each(this.types, type => {
                        if(type.name === value.name) {
                            type.interval = value.interval;
                            type.amount = value.amount;
                        }
                    });
                })
            },
            onInputChanged() {
                let incomeData = _.map(this.types, type => {
                    return {
                        name: type.name,
                        amount: type.amount,
                        interval: type.interval,
                    }
                })

                this.$emit('updated', {member: this.member, amounts: incomeData});
            }
        }
    }
</script>
